import axios from 'axios';

/**
 * What went wrong, as one line to put in front of the user.
 *
 * The api answers a failure in three shapes: a validation error carries a field bag under
 * `errors`, everything else a single `message`, and a request that never reached the api at all
 * (offline, timeout, a proxy answering html) carries neither. Knowing that is this function's
 * job, so that a caller only has to write `catch (e) { error.value = apiErrorMessage(e) }` -
 * without an `any` and without repeating the shape at every call site.
 */
export function apiErrorMessage(e: unknown): string {
	if (axios.isAxiosError(e)) {
		const data = e.response?.data as { message?: string; errors?: Record<string, string[]> } | undefined;

		// A 422 names every field it rejected; the top level `message` only ever repeats the first.
		const fields = data?.errors ? Object.values(data.errors).flat() : [];
		if (fields.length) return fields.join(' ');

		return data?.message || e.message;
	}

	return e instanceof Error ? e.message : String(e);
}
